import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarEmoji } from '@factorialco/f0-react'
import { Widget } from '@factorialco/f0-react/dist/experimental'
import { CompletedTrainingsOverviewDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

export const CompletedTrainings = () => {
  const { access } = useCurrentSession()
  const { data, loading } = useQuery(CompletedTrainingsOverviewDocument, {
    variables: { accessId: access.id },
  })

  if (loading) return <Loading />

  if (!data) return null

  const trainings = data?.trainings?.trainingsConnection?.nodes ?? []
  const totalTrainings = trainings?.length ?? 0

  // Count trainings where the attendance status is completed adn the training is active
  const completedTrainings =
    trainings?.length > 0
      ? trainings.filter(
          (training) =>
            training.trainingAttendanceStatus === 'completed' && training?.status == 'active'
        )?.length
      : 0

  return (
    <Widget
      header={{
        title: i18n.t('trainings.my_trainings_revamp.overview.completed_courses_title'),
      }}
    >
      <Box
        width="full"
        flexDirection="column"
        justifyContent="center"
        gap={'s16'}
        style={{ minHeight: '50px' }}
      >
        {totalTrainings > 0 ? (
          <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
            <Box gap="s4" flexDirection="column">
              <Text color="grey700" size="300">
                {i18n.t('trainings.my_trainings_revamp.overview.completed_courses')}
              </Text>
              <Text color="grey800" size="400" weight="bold">
                {completedTrainings}/{totalTrainings}
              </Text>
            </Box>
            <Box gap="s4">
              <F0AvatarEmoji emoji={'🎯'} size="xl" />
            </Box>
          </Box>
        ) : (
          <Box gap="s4" flexDirection="row" justifyContent="spaceBetween" alignItems="center">
            <Text color="grey700" size="300">
              {i18n.t('trainings.my_trainings_revamp.overview.no_trainings_available')}
            </Text>
            <Box gap="s4">
              <F0AvatarEmoji emoji={'🎯'} size="xl" />
            </Box>
          </Box>
        )}
      </Box>
    </Widget>
  )
}
